import { isFilterValueHasRestrictedPropertiesUsingRestrictedValueCheck } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { useContext, useEffect } from 'react';
import RestrictedFiltersViewState from 'customer-data-filters-ui/components/common/RestrictedFiltersViewState';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import SegmentationFiltersSidePanelLayout from './SegmentationFiltersSidePanelLayout';
import SegmentationFiltersEmbeddedLayout from './SegmentationFiltersEmbeddedLayout';
import FilterUserAction from 'customer-data-filters-ui/filterQueryFormat/FilterUserAction';
import { USED_SEGMENTATION_FILTERS } from 'customer-data-filters-ui/filterQueryFormat/UsageActionTypes';
import { VIEWED_FILTERS } from 'customer-data-filters-ui/filterQueryFormat/UsageSubActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SegmentationFiltersUI = () => {
  const {
    props: {
      layout,
      value,
      uiMessages: {
        restrictedFiltersMessage
      },
      onUserAction
    }
  } = useContext(SegmentationFiltersInstanceContext);
  useEffect(() => {
    onUserAction(FilterUserAction({
      action: USED_SEGMENTATION_FILTERS,
      subAction: VIEWED_FILTERS
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isFilterValueHasRestrictedPropertiesUsingRestrictedValueCheck(value)) {
    return /*#__PURE__*/_jsx(RestrictedFiltersViewState, {
      message: restrictedFiltersMessage
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [layout === 'embedded' && /*#__PURE__*/_jsx(SegmentationFiltersEmbeddedLayout, {}), layout === 'panel' && /*#__PURE__*/_jsx(SegmentationFiltersSidePanelLayout, {})]
  });
};
export default SegmentationFiltersUI;